// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + {"440":"datadogProfiler","581":"datadogRecorder"}[chunkId] + "." + {"440":"e9fb968b33f4159f","581":"81c3d96b3fbf3756"}[chunkId] + ".js";
};